module.exports = __webpack_public_path__ + "media/images/talent/mv-slider09-c1a55e1203c6d7f3b3afc81867bb17fd.png";